export const VenueMapView = () => null
